import $ from 'jquery';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { updatePassword } from 'aws-amplify/auth';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/solid';
import SharedButton from '@/global/Button/Button';
import Swal from 'sweetalert2';

export default function ChangePassword({ onClose }) {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isOldPassVisible, setIsOldPassVisible] = useState(false);
  const [isNewPassVisible, setIsNewPassVisible] = useState(false);
  const [isConfirmPassVisible, setIsConfirmPassVisible] = useState(false);

  const toggleVisibility = setter => setter(prev => !prev);

  const validateInputs = () => {
    if (!oldPassword.trim()) {
      setErrorMessage('Old Password is required');
      return false;
    }
    if (!newPassword.trim()) {
      setErrorMessage('New Password is required');
      return false;
    }
    if (newPassword !== confirmPassword) {
      setErrorMessage('Passwords do not match');
      return false;
    }
    return true;
  };

  const handleSubmit = async evt => {
    evt.preventDefault();
    setErrorMessage('');

    if (!validateInputs()) return;

    try {
      await updatePassword({ oldPassword, newPassword });
      Swal.fire({
        title: 'Reset password successfully',
        text: 'Your password has been reset successfully.',
        icon: 'success',
        confirmButtonText: 'OK',
        confirmButtonColor: '#3B82F6',
      });
      navigate('/Profile-area');
      setTimeout(() => {
        if (onClose) onClose();
      }, 5000);
    } catch (error) {
      setErrorMessage(error.message);
    }
  };

  return (
    <form onSubmit={handleSubmit} autoComplete="off">
      <div className="text-left w-full">
        <div className="flex justify-between">
          <label className="text-xs font-semibold text-gray-600 ml-2 text-uppercase">Old Password:</label>
          <button type="button" className="eye-icon" onClick={() => toggleVisibility(setIsOldPassVisible)}>
            {isOldPassVisible ? (
              <EyeIcon className="w-4 h-4 mb-1" />
            ) : (
              <EyeSlashIcon className="w-4 h-4 mb-1" />
            )}
          </button>
        </div>
        <div>
          <input
            onChange={e => setOldPassword(e.target.value)}
            type={isOldPassVisible ? 'text' : 'password'}
            className="form-input"
            placeholder="Enter Old Password"
          />
        </div>
      </div>

      <div className="flex mt-4 gap-4 w-full">
        <div className="w-1/2">
          <div className="flex justify-between">
            <label className="text-xs font-semibold text-gray-600 ml-2 text-uppercase">New Password:</label>
            <button type="button" className="eye-icon" onClick={() => toggleVisibility(setIsNewPassVisible)}>
              {isNewPassVisible ? (
                <EyeIcon className="w-4 h-4 mb-1" />
              ) : (
                <EyeSlashIcon className="w-4 h-4 mb-1" />
              )}
            </button>
          </div>
          <div>
            <input
              onChange={e => setNewPassword(e.target.value)}
              type={isNewPassVisible ? 'text' : 'password'}
              className="form-input"
              placeholder="Enter New Password"
            />
          </div>
        </div>
        <div className="w-1/2">
          <div className="flex justify-between">
            <label className="text-xs font-semibold text-gray-600 ml-2 text-uppercase">
              Confirm Password:
            </label>
            <button
              type="button"
              className="eye-icon"
              onClick={() => toggleVisibility(setIsConfirmPassVisible)}
            >
              {isConfirmPassVisible ? (
                <EyeIcon className="w-4 h-4 mb-1" />
              ) : (
                <EyeSlashIcon className="w-4 h-4 mb-1" />
              )}
            </button>
          </div>
          <div>
            <input
              onChange={e => setConfirmPassword(e.target.value)}
              type={isConfirmPassVisible ? 'text' : 'password'}
              className="form-input"
              placeholder="Confirm New Password"
            />
          </div>
        </div>
      </div>

      <span
        className="text-gray-600 hover:text-blue-950 text-xs mr-2 cursor-pointer flex justify-end mt-2 font-semibold"
        onClick={onClose}
      >
        Cancel
      </span>

      <div className="container-contact100-form-btn">
        <SharedButton type="submit" variant="gradient" className="w-1/4">
          Change Password
        </SharedButton>
      </div>

      {errorMessage && <p className="text-center">{errorMessage}</p>}
    </form>
  );
}
